// extracted by css-extract-rspack-plugin
export default {"emptyPreview":"oysxp4r1JHUfCgiG"};